export const SKIPPED_FIELDS_KEY = ['divider', "testspace", "testSpace"];

export const CRFStatus = Object.freeze({
  PENDING: "Pending",
  PENDING_TO_VERIFY: "Verification_Pending",
  ERROR: "Error",
  COMPLETED: "Completed",
  PENDING_EXTERNAL_VERIFICATION: "External_Verification_Pending",
  WITHDRAWAL: "Withdrawal"
})

// Subject status constants
export const SUBJECT_STATUSES = {
  SCREENING_FAILURE: 'Screening_Failure',
  ENROLLMENT_FAILURE: 'Enrollment_Failure',
  WITHDRAWAL: 'Withdrawal',
  ON_HOLD: 'On_Hold',
  COMPLETED: 'Completed',
  PENDING: 'Pending',
  PENDING_VERIFICATION: 'Verification_Pending',
  PENDING_EXTERNAL_VERIFICATION: 'External_Verification_Pending',
};


export const AUDIO_LANGUAGES = [
  {
    locale: 'en-US',
    name: 'English (US)'
  },
  {
    locale: 'hi-IN',
    name: 'Hindi'
  },
  {
    locale: 'en-AU',
    name: 'English (Australia)'
  },
  {
    locale: 'en-GB',
    name: 'English (British)'
  },
  {
    locale: 'es-ES',
    name: 'Spanish (European)'
  },
  {
    locale: 'ja-JP',
    name: 'Japanese'
  },
  {
    locale: 'pt-BR',
    name: 'Portuguese'
  }
]